<div class="flex flex-col px-6 py-4 gap-4 overflow-y-auto">
	@if (modalStatus_()) {
		<div class="flex flex-col m-[74px] items-center justify-center h-full">
			<div class="flex gap-2 mb-6 items-center">
				<ui-status size="md" [status]="modalStatus_()" />
			</div>

			<img
				alt="Package Sending"
				src="/assets/images/undraw/undraw_newsletter_q7fx 2.svg"
				class="max-w-[272px] mb-6"
			/>
		</div>
	} @else {
		<h5 class="font-medium h5">Recipients</h5>
		<div class="flex flex-wrap gap-2">
			@for (recipient of recipients_(); track recipient.id) {
				<div
					class="pr-4 py-2 pl-2 bg-gray-50 flex items-center rounded-lg gap-2"
				>
					<ui-avatar
						[initials]="recipient.initials"
						[variant]="variantOrderList[$index % variantOrderList.length]"
					/>
					<div class="flex flex-col gap-0.5">
						<span class="text-sm text-gray-900">{{ recipient.name }}</span>
						<span class="text-xs text-gray-500">{{ recipient.email }}</span>
					</div>
				</div>
			}
		</div>
		<ui-button
			label="Edit Recipients"
			size="sm"
			[preset]="BUTTON_PRESETS.LOW_EMPHASIS"
			icon="edit"
			(click)="editRecipients()"
		></ui-button>
		<div class="flex flex-col gap-2 mt-4">
			<h5 class="font-medium h5">Add a Note</h5>
			<p class="p-sm">
				This note will appear in the email your recipients receive.
			</p>
		</div>
		<app-text-area
			(debounce)="onNoteDebounced($event)"
			[(ngModel)]="note"
			[rows]="4"
		></app-text-area>
		@if (isLoggedInUserAdmin()) {
			<div class="flex">
				<core-button-secondary-fill (click)="goToESigningSettings()">
					Edit Default Note
				</core-button-secondary-fill>
			</div>
		}
	}
</div>
